import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { saveVariantEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const postCreateNewVariant = createApi(saveVariantEndpoint, "POST");

const newVariantSlice = createSlice({
  name: "NewVariantSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCreateNewVariant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postCreateNewVariant.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postCreateNewVariant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default newVariantSlice.reducer;
